<div class="d-flex justify-content-center align-items-center flex-column h-100">
    <p><b>{{errorType | translate}}</b></p>
    <button *ngIf="redirectUrl" (click)="redirect()">{{'ERROR.REDIRECT' | translate}}</button>
</div>